import { render } from "./ConfirmDeleteModal.vue?vue&type=template&id=05c1b1bb"
import script from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"
export * from "./ConfirmDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__